export default __webpack_public_path__ + "static/op-e82b7da2fc0b89aba91f77ea8ddc12ac.png";